import { createFileRoute } from '@tanstack/react-router';

import GroupDetails from '@/ui/pages/GroupDetails/GroupDetails';

export const Route = createFileRoute('/_dashboard/groups/$id/')({
  component: GroupDetails,
});
